/** Active FIFA World Cup edition for Predict90 */
export const WC_ACTIVE_SEASON = 2026;

/** Default stage filter for UAT (Round of 32) */
export const WC_DEFAULT_STAGE = "LAST_32";

export const WC_STAGE_OPTIONS = [
  { id: "LAST_32", label: "Round of 32" },
  { id: "LAST_16", label: "Round of 16" },
  { id: "QUARTER_FINALS", label: "Quarter-finals" },
  { id: "SEMI_FINALS", label: "Semi-finals" },
  { id: "THIRD_PLACE", label: "Third place" },
  { id: "FINAL", label: "Final" },
  { id: "GROUP_STAGE", label: "Group stage" },
  { id: "", label: "All stages" },
];

/** World Cup leaderboard: overall + each round in tournament order */
export const WC_LEADERBOARD_STAGE_OPTIONS = [
  { id: "all", label: "Overall" },
  { id: "GROUP_STAGE", label: "Group stage" },
  { id: "LAST_32", label: "Round of 32" },
  { id: "LAST_16", label: "Round of 16" },
  { id: "QUARTER_FINALS", label: "Quarter-finals" },
  { id: "SEMI_FINALS", label: "Semi-finals" },
  { id: "THIRD_PLACE", label: "Third place" },
  { id: "FINAL", label: "Final" },
];

export const WC_LEADERBOARD_STAGE_STORAGE_KEY = "leaderboard_wc_stage_filter";

const STAGE_LABELS = {
  GROUP_STAGE: "Group Stage",
  LAST_32: "Round of 32",
  LAST_16: "Round of 16",
  QUARTER_FINALS: "Quarter-finals",
  SEMI_FINALS: "Semi-finals",
  THIRD_PLACE: "Third place",
  FINAL: "Final",
};

export function formatWorldCupStageLabel(stage, matchday) {
  if (!stage) return "World Cup";
  const base = STAGE_LABELS[stage] || stage.replace(/_/g, " ");
  if (stage === "GROUP_STAGE" && matchday) {
    return `${base} — MD${matchday}`;
  }
  return base;
}

export const WC_STAGE_STORAGE_KEY = "predictions_wc_stage_filter";

export function getStoredWorldCupStageFilter() {
  try {
    const raw = localStorage.getItem(WC_STAGE_STORAGE_KEY);
    if (raw === "" || WC_STAGE_OPTIONS.some((o) => o.id === raw)) return raw ?? WC_DEFAULT_STAGE;
  } catch (_) {
    /* ignore */
  }
  return WC_DEFAULT_STAGE;
}

export function setStoredWorldCupStageFilter(stage) {
  try {
    localStorage.setItem(WC_STAGE_STORAGE_KEY, stage ?? "");
  } catch (_) {
    /* ignore */
  }
}

export function getStoredWorldCupLeaderboardStage() {
  try {
    const raw = localStorage.getItem(WC_LEADERBOARD_STAGE_STORAGE_KEY);
    if (raw === "all" || WC_LEADERBOARD_STAGE_OPTIONS.some((o) => o.id === raw)) {
      return raw ?? "all";
    }
  } catch (_) {
    /* ignore */
  }
  return "all";
}

export function setStoredWorldCupLeaderboardStage(stage) {
  try {
    localStorage.setItem(WC_LEADERBOARD_STAGE_STORAGE_KEY, stage ?? "all");
  } catch (_) {
    /* ignore */
  }
}
